import { MyPageUserImagePostInputModel } from "../../api/v1/mypage/user/image/PostInputModel"
import { postMyPageUserImage } from "../../api/v1/mypage/user/image/post"

export const postMyUserImage = (imageFile: File): Promise<void> => {
  const model = new MyPageUserImagePostInputModel({
    imageFile,
  })

  return postMyPageUserImage(model)
}
